import { ContainerOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 8px;
`

interface FlagDeviationsModalFooterProps {
  onCancel: () => void
  onSubmit?: () => void
}

const FlagDeviationsModalFooter = memo(
  ({ onCancel, onSubmit }: FlagDeviationsModalFooterProps) => {
    return (
      <Footer>
        <Button onClick={onCancel} type="text">
          {t('Cancel')}
        </Button>
        {onSubmit && (
          <Button
            icon={<ContainerOutlined />}
            type="primary"
            onClick={onSubmit}
          >
            {t(
              'workspaceDetailsPage.workspaceSmartFunctionPanel.deviationConfirmationModal.flagDeviationsButton'
            )}
          </Button>
        )}
      </Footer>
    )
  }
)

export default FlagDeviationsModalFooter
